import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { BUSINESS } from "@/constants/business";

export default function WhatsAppButton() {
    return (
        <motion.a
            href={BUSINESS.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-chat-button"
            aria-label="Chat with Masons Automotive on WhatsApp"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1.4, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.94 }}
            className="fixed bottom-6 right-6 z-50 flex items-center gap-2.5 bg-[#25D366] text-[#062a15] rounded-full pl-4 pr-5 py-3.5 font-bold text-xs uppercase tracking-widest shadow-lg shadow-[#25D366]/30 hover:bg-[#2ee074] transition-colors duration-200"
        >
            <MessageCircle className="w-5 h-5" />
            WhatsApp
        </motion.a>
    );
}
